import { ADMIN_ROLES } from '../rules/frontend.rules';

/** 是否应进入管理后台（/home） */
export function canAccessAdminDashboard(role) {
  if (!role) return false;
  return ADMIN_ROLES.includes(role);
}

/** 根据用户角色返回登录后的默认路径 */
export function getDefaultRouteForUser(user) {
  if (canAccessAdminDashboard(user?.role)) {
    return '/home';
  }
  return '/school';
}

export function parseStoredUserInfo() {
  try {
    const raw = localStorage.getItem('user_info');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}
